import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import soltLogo from '../../assets/logo.png';
import appleIconWhite from '../../assets/apple-icon-white.png';
import {BRAND_TAGLINE} from '../../constants/brand';
import {APP_STORE_URL} from '../../constants/app';
import {GeoCityConfig} from '../../data/geoRoutes';
import './GeoPages.css';

const GEO_CTA_LINE =
    'See friends & foodies eats. Track your own. Save what you love.';

type GeoPageLayoutProps = {
    geo: GeoCityConfig;
    breadcrumbLabel: string;
    children: ReactNode;
    /** Wider layout for visual city hub */
    variant?: 'default' | 'hub';
};

const GeoPageLayout: React.FC<GeoPageLayoutProps> = ({
    geo,
    breadcrumbLabel,
    children,
    variant = 'default',
}) => {
    return (
        <div className={`geo-page${variant === 'hub' ? ' geo-page--hub' : ''}`}>
            <header className="geo-page-header">
                <div className="geo-page-header-inner">
                    <Link to="/" aria-label="Solt home">
                        <img src={soltLogo} alt="Solt" className="geo-page-logo"/>
                    </Link>
                    <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="geo-page-header-cta"
                    >
                        Get the app
                    </a>
                </div>
                <nav className="geo-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Solt</Link>
                    <span aria-hidden="true"> / </span>
                    <span>{geo.countryName}</span>
                    <span aria-hidden="true"> / </span>
                    <Link to={`/${geo.countrySlug}/${geo.citySlug}`}>{geo.cityName}</Link>
                    {breadcrumbLabel !== geo.cityName && (
                        <>
                            <span aria-hidden="true"> / </span>
                            <span>{breadcrumbLabel}</span>
                        </>
                    )}
                </nav>
            </header>

            <main className="geo-page-main">{children}</main>

            <section className="geo-page-cta" aria-labelledby="geo-cta-heading">
                <h2 id="geo-cta-heading">{BRAND_TAGLINE}</h2>
                <p>{GEO_CTA_LINE}</p>
                <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
                    <button type="button" className="geo-ios-button">
                        <img src={appleIconWhite} alt=""/>
                        Download on the App Store
                    </button>
                </a>
            </section>

            <footer className="geo-page-footer">
                <img src={soltLogo} alt=""/>
                <span>{BRAND_TAGLINE}</span>
                <p className="geo-page-footer-note">Made in Europe ❤️</p>
            </footer>
        </div>
    );
};

export default GeoPageLayout;
